import { useEffect, useRef, useState, type ReactNode } from 'react';

/** Fades a section in when it scrolls into view; CSS turns the motion off for prefers-reduced-motion. */
export function Reveal({ children, id, label }: { children: ReactNode; id?: string; label?: string }) {
  const ref = useRef<HTMLElement | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setVisible(true);
        io.disconnect();
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <section ref={ref} id={id} aria-label={label} className={`reveal ${visible ? 'is-visible' : ''}`}>
      {children}
    </section>
  );
}
